import { useRef, useState, useEffect } from "react";
import Button from "../Button/Button";
import Modal from "./Modal";
import { CSSTransition } from "react-transition-group";
import ReactPortal from "components/ReactPortal/ReactPortal";
import { useDeleteModalContext } from "context/DeleteModalContext";

import styles from "components/UI/Modals/Modal.module.scss";

const generateRandomCode = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

const DeleteModal = () => {
  const ref = useRef();
  const { visible, toggle, confirm } = useDeleteModalContext();
  const [randomCode, setRandomCode] = useState("");
  const [userInput, setUserInput] = useState("");
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

  useEffect(() => {
    if (visible) {
      const newCode = generateRandomCode();
      setRandomCode(newCode);
      setUserInput("");
      setIsConfirmDisabled(true);
    }
  }, [visible]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setUserInput(value);
    setIsConfirmDisabled(value !== randomCode);
  };

  return (
    <ReactPortal containerElement="body">
      <CSSTransition
        in={visible}
        nodeRef={ref}
        classNames={{
          enter: "",
          enterActive: styles.animFadeInTop,
          exit: "",
          exitActive: styles.animFadeOutTop,
        }}
        timeout={{ enter: 500, exit: 300 }}
        unmountOnExit
      >
        <Modal
          ref={ref}
          title="Delete"
          position="top"
          maxWidth="44rem"
          onClose={toggle}
        >
          <p style={{ textAlign: "center" }}>
            Are you sure you want to permanently delete this?
          </p>
          <p style={{ textAlign: "center", fontSize: "1.2rem", fontWeight: "bold", color: "var(--text-color)" }}>
            <h2>{randomCode}</h2>
          </p>
          <input
            type="text"
            value={userInput}
            onChange={handleInputChange}
            placeholder="Input 4 digit code to confirm delete"
            className={styles.inputField}
          />
          <div className={styles.actions}>
            <Button onClick={toggle} className={styles.btnClose}>
              No, Cancel
            </Button>
            <Button
              onClick={async () => {
                confirm();
                // setTimeout(() => {
                //   window.location.reload();
                // }, 2000);
              }}
              className={styles.btnConfirm}
              disabled={isConfirmDisabled}
            >
              Confirm
            </Button>
          </div>
        </Modal>
      </CSSTransition>
    </ReactPortal>
  );
};

export default DeleteModal;
